import { render, staticRenderFns } from "./puzzle_orders.vue?vue&type=template&id=77fddf6a&"
import script from "./puzzle_orders.vue?vue&type=script&lang=js&"
export * from "./puzzle_orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports